export default "__VITE_ASSET__1a636588__"